/* eslint-disable */

import exp from 'constants';
import { TNode } from '../common';
import type { TextareaProps, CollapsePanelProps, AvatarProps } from 'tdesign-vue-next';

export interface TdChatItemProps {
  /**
   * 自定义的操作内容
   */
  actions?: string | TNode;
  /**
   * 动画效果，支持「渐变加载动画」,「闪烁加载动画」, 「骨架屏」三种
   * @default skeleton
   */
  animation?: 'skeleton' | 'moving' | 'gradient';
  /**
   * 自定义的头像配置
   */
  avatar?: String | AvatarProps | TNode;
  /**
   * 对话单元的内容
   */
  content?: string | TNode;
  /**
   * 对话单元的时间配置
   */
  datetime?: string | TNode;
  /**
   * 自定义的昵称
   */
  name?: string | TNode;
  /**
   * 值为false不显示思维链，为string则显示内置推理内容交互，为对象则单独配置推理内容
   * @default false
   */
  reasoning?: boolean | TdChatReasoning;
  /**
   * 角色，不同选项配置不同的样式，支持类型包括用户、助手、错误、模型切换、系统消息
   */
  role?: 'user' | 'assistant' | 'error' | 'model-change' | 'system';
  /**
   * 新消息是否处于加载状态，加载状态默认显示骨架屏，接口请求返回数据时请将新消息加载状态置为false
   * @default false
   */
  textLoading?: boolean;
  /**
   * 气泡框样式，支持基础、线框、文字三种类型
   * @default text
   */
  variant?: 'base' | 'outline' | 'text';
}
export interface TdChatProps {
  /**
   * 布局
   */
  layout?: Layout;
  /**
   * 倒序渲染
   */
  reverse?: boolean;
    /**
   * 数据
   */
  data?: Array<TdChatItemProps>;
  /**
   * 接口请求中
   */
  textLoading?: boolean;
  /** 清空历史按钮，值为 true 显示默认操作按钮，值为 false 不显示任何内容，值类型为 Function 表示自定义 */
  clearHistory?: boolean | TNode;
  /** 点赞差评复制重新生成按钮集合，值为true显示默认操作按钮 */
    /**
   * 自定义操作按钮的插槽
   */
  actions?: TNode;
  // 流式数据加载中
  isStreamLoad?: boolean;
  onClear?: (context: { e: MouseEvent }) => void;
}
export interface TdChatListProps {
  /**
   * 数据
   */
  data?: Array<TdChatItemProps>;
  /**
   * 流式消息加载中
   */
  textLoading?: boolean;
  onScroll?: (e: Event) => void;
};
export interface TdChatContentProps {
  content?: string;
  role?: string;
  isNormalText?: boolean;
  textLoading: boolean;
}
export interface TdChatActionsProps {
  isGood?: Boolean;
  isBad?: Boolean;
  content?: string;
  disabled?: boolean;
    /**
   * 点击时触发
   */
  onOperation?: (value:string, context: { e: MouseEvent, index?: number, item?: TdChatItemProps }) => void;
}
export interface TdChatInputProps {
  placeholder?: string;
  disabled?: boolean;
  value: string;
  modelValue: string;
  defaultValue: string;
    /**
   * 高度自动撑开。 autosize = true 表示组件高度自动撑开，同时，依旧允许手动拖高度。如果设置了 autosize.maxRows 或者 autosize.minRows 则不允许手动调整高度
   * @default false
   */
  autosize?: boolean | { minRows?: number; maxRows?: number };
  onSend?: 	(value:string, context: { e: MouseEvent | KeyboardEvent }) => void;
  onStop?: 	(value:string, context: { e: MouseEvent }) => void;
  onChange?: (value:string, context: { e: InputEvent | MouseEvent | KeyboardEvent }) => void;
  onBlur?: (value:string, context: { e: FocusEvent }) => void;
  onFocus?: (value:string, context: { e: FocusEvent }) => void;
}
export interface TdChatSenderProps {
  /**
   * 是否禁用输入框
   * @default false
   */
  disabled?: boolean;
  /**
   * 输入框默认文案
   * @default ''
   */
  placeholder?: string;
  /**
   * 输入框左下角区域扩展
   */
  prefix?: string | TNode;
  /**
   * 中止按钮是否可点击。等流式数据全部返回结束置为false，注意跟textLoading的控制时机不是同一个
   * @default false
   */
  stopDisabled?: boolean;
  /**
   * 输入框右下角区域扩展
   */
  suffix?: string | TNode;
  /**
   * 透传给  Textarea 组件的全部属性
   */
  textareaProps?: TextareaProps;
  /**
   * 输入框的值
   * @default ''
   */
  value?: string;
  /**
   * 输入框的值，非受控属性
   * @default ''
   */
  defaultValue?: string;
  /**
   * 输入框的值
   * @default ''
   */
  modelValue?: string;
  /**
   * 输入框聚焦时触发
   */
  onBlur?: (value: string, context: { e: FocusEvent }) => void;
  /**
   * 输入框值发生变化时触发
   */
  onChange?: (value: string, context: { e: InputEvent | MouseEvent | KeyboardEvent }) => void;
  /**
   * 输入框聚焦时触发
   */
  onFocus?: (value: string, context: { e: FocusEvent }) => void;
  /**
   * 点击消息发送的回调方法
   */
  onSend?: (value: string, context: { e: MouseEvent | KeyboardEvent }) => void;
  /**
   * 点击消息终止的回调方法
   */
  onStop?: (value: string, context: { e: MouseEvent }) => void;
  onFileSelect?: (params: {
    files: File[];
    name: UploadActionType;
  }) => void;
}
export interface MetaData {
  /**
   * 角色头像
   * @description 可选参数，如果不传则使用默认头像
   */
  avatar?: string;
  /**
   * 名称
   * @description 可选参数，如果不传则使用默认名称
   */
  name?: string;
  /**
   * 附加数据
   * @description 可选参数，如果不传则使用默认名称
   */
  [key: string]: any;
}
export interface TdChatItemMeta {
  avatar?: string;
  name?: string;
  role?: string;
  datetime?: string;
}
export interface TdChatReasoningProps {
  /**
   * 透传给 CollapsePanel 组件的全部属性
   */
  collapsePanelProps?: CollapsePanelProps;
  /**
   * 当前折叠面板展开图标。优先级低于collapsePanelProps.expandIcon
   */
  expandIcon?: TNode;
  /**
   * 展开图标位置，可选项：left/right
   * @default right
   */
  expandIconPlacement?: 'left' | 'right';
  /**
   * 折叠面板头内容。优先级低于collapsePanelProps.header
   */
  header?: TNode;
  /**
   * 折叠面板尾内容。优先级低于collapsePanelProps.headerRightContent
   */
  headerRightContent?: TNode;
  /**
   * 展开图标点击事件
   */
  onExpandChange?: (value: boolean) => void;

  /**
   * 是否折叠
   */
  collapsed?: boolean;
}
export type ModelRoleEnum = 'assistant' | 'user' | 'error' | 'model-change' | 'system';

export type Variant = 'text'| 'base' | 'outline'
export type Layout = 'single' | 'both'
export type animation = 'skeleton' | 'moving' | 'gradient'
export interface FetchSSEOptions {
  success?: (res: SSEEvent) => void; // 流式数据解析成功回调
  fail?: () => void; // 流式请求失败回调
  complete?: (isOk: Boolean, msg?: String, requestid?: String) => void; // 流式请求完成回调
}
export interface SSEEvent {
  type: string | null;
  data: string | null;
}
export interface BackBottomParams {
  behavior?: 'auto' | 'smooth';
}

/** 组件实例方法 */
export interface ChatInstanceFunctions {
  /**
   * 滚动到底部对话列表底部
   */
  scrollToBottom?: (params?:BackBottomParams) => void;
}
export interface TdChatReasoning {
  expandIconPlacement?: 'left' | 'right';
  onExpandChange?: (isExpand: boolean) => void;
  collapsePanelProps?: Object;
  collapsed?: boolean;
}

export type UploadActionType = 'uploadAttachment' | 'uploadImage';

export interface UploadActionConfig {
  /**
   * 动作名称，标识上传类型
   */
  name: UploadActionType;
  /**
   * 上传属性配置（可选）
   */
  uploadProps?: {
    /**
     * 是否允许多选
     */
    multiple?: boolean;
    /**
     * 接受的文件类型
     */
    accept?: string;
  };
  /**
   * 上传动作处理函数
   * @param params - 上传参数对象
   * @param params.files - 上传的文件列表
   * @param params.name - 上传动作名称
   */
  action: (params: {
    files: File[];
    name: UploadActionType;
  }) => void;
}